import React from 'react';
import { Avatar, Typography, Box, SxProps, Theme } from '@mui/material';
import { IProject } from '../../types/global/helper';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';

interface RoundImageWithTextProps {
    imageSize?: number;
    project?: IProject;
    containerStyles?: SxProps<Theme>;
    onClick?: () => void;
}

const ProjectAvatar: React.FC<RoundImageWithTextProps> = ({ imageSize = 50, containerStyles, project, onClick }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Box display="flex" alignItems="center" sx={containerStyles}>
            <Avatar
                src={project?.feature_image}
                alt={project?.title}
                onClick={onClick}
                sx={{
                    width: imageSize,
                    height: imageSize,
                    marginRight: 1,
                    border: `0.2px solid ${theme[themeStyle].tag_white}`,
                }}
            />
            <Typography
                style={{
                    fontFamily: FONT_ENUM.REGULAR_HEADER,
                    color: theme[themeStyle].lightWhite,
                    fontSize: 12,
                    textTransform: 'capitalize',
                }}>
                {project?.title}
            </Typography>
        </Box>
    );
};

export { ProjectAvatar };
